import { render } from "./LockDesigner.vue?vue&type=template&id=2cfa8c4e"
import script from "./LockDesigner.vue?vue&type=script&lang=js"
export * from "./LockDesigner.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\src\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__